import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  img {
    width: 100%;
  }
`;
